import React from "react";

import {
  Box,
  Button,
  Heading,
  Inline,
  Link,
  RichText as RichTextComponent,
  VStack,
  Wrapper,
} from "components";

function HomeIntro({
  introductory_button_label,
  introductory_button_link,
  introductory_description,
  introductory_title,
  secondary_button_label,
  secondary_button_link,
}) {
  if (introductory_title || introductory_description) {
    return (
      <Wrapper
        id="home-body"
        pt={{ _: "layout.7", md: "layout.6" }}
        pb={{ _: "layout.4", md: "layout.6" }}
      >
        <Box>
          <VStack space="layout.3">
            {introductory_title && introductory_title.text && (
              <Heading children={introductory_title.text} as="h2" size={700} />
            )}

            {introductory_description && introductory_description.html && (
              <RichTextComponent
                html={introductory_description.html}
                size={400}
                maxWidth="65ch"
              />
            )}
            <Inline space="spacing.4">
              {introductory_button_link &&
                introductory_button_link.url &&
                introductory_button_label && (
                  <Link href={introductory_button_link.url}>
                    <Button
                      children={introductory_button_label}
                      appearance="primary"
                      intent="primary"
                      round={true}
                    />
                  </Link>
                )}
              {secondary_button_link &&
                secondary_button_link.url &&
                secondary_button_label && (
                  <Link href={secondary_button_link.url}>
                    <Button
                      children={secondary_button_label}
                      appearance="secondary"
                      intent="primary"
                      round={true}
                    />
                  </Link>
                )}
            </Inline>
          </VStack>
        </Box>
      </Wrapper>
    );
  } else {
    return null;
  }
}

export default HomeIntro;
